import { Handle, Position } from '@xyflow/react'

export function DocumentNode({ data }) {
    
    return (
        // We add this class to use the same styles as React Flow's default nodes.
        <div className="react-flow__node-default" style={{ width: '250px', textAlign: 'left', padding: 0 }}>
            <div style={{ padding: '10px', borderBottom: '1px solid black' }}>
                <span style={{ fontWeight: 'bold' }}>{data.name}</span>
                <div style={{ fontSize: '10px' }}>
                    {data.bookType} - Volume: {data.bookVolume} - Page: {data.bookPage}
                </div>
            </div>
            <div style={{ padding: '10px' }}>
                <div><span style={{ fontWeight: 'bold' }}>Type:</span> {data.instrumentType}</div>
                <div><span style={{ fontWeight: 'bold' }}>Inst Date:</span> {data.instrumentDate?.split('T')[0]}</div>
                <div><span style={{ fontWeight: 'bold' }}>File Date:</span> {data.fileDate?.split('T')[0]}</div>
                <div style={{ fontWeight: 'bold' }}>Grantors:</div>
                <ul style={{ margin: 0, padding: '0 1rem' }}>
                    {data.grantors.map(gtor => <li key={gtor.id}>{gtor.name}</li>)}
                </ul>
                <div style={{ fontWeight: 'bold' }}>Grantees:</div>
                <ul style={{ margin: 0, padding: '0 1rem' }}>
                    {data.grantees.map(gtee => <li key={gtee.id}>{gtee.name}</li>)}
                </ul>
            </div>
            <Handle type="target" position={Position.Top} />
            <Handle type="source" position={Position.Bottom} />
        </div>
    )
}
